/** Referências dos realizados das metas */
export interface MetaReferenciaRealizado {
    id: number;
    nome: string;
}

export const referenciaRealizadoPedido: MetaReferenciaRealizado = {id: 1, nome: 'Pedidos'};
export const referenciaRealizadoNotaFiscal: MetaReferenciaRealizado = {id: 2, nome: 'Notas Fiscais'};
export const referenciaRealizadoPedidoNotaFiscal: MetaReferenciaRealizado = {id: 3, nome: 'Pedidos e Notas Fiscais'};

export const referenciasRealizados: MetaReferenciaRealizado[] = [
    referenciaRealizadoPedido,
    referenciaRealizadoNotaFiscal,
    referenciaRealizadoPedidoNotaFiscal
];

/** Verifica se a referência do realizado é pedido  */
export function isReferenciaRealizadoPedido(referenciaRealizado: number): boolean {
    return referenciaRealizado === referenciaRealizadoPedido.id;
}

/** Verifica se a referência do realizado é nota fiscal */
export function isReferenciaRealizadoNotaFiscal(referenciaRealizado: number): boolean {
    return referenciaRealizado === referenciaRealizadoNotaFiscal.id;
}

/** Verifica se a referência do realizado é pedido e nota fiscal  */
export function isReferenciaRealizadoPedidoNotaFiscal(referenciaRealizado: number): boolean {
    return referenciaRealizado === referenciaRealizadoPedidoNotaFiscal.id;
}
